import { render, staticRenderFns } from "./TemplateTab1.vue?vue&type=template&id=3ccd5738&"
import script from "./TemplateTab1.vue?vue&type=script&lang=ts&"
export * from "./TemplateTab1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports